<template>
  <div>
    <div class="top">
      <li class="left"></li>
      <li class="right"></li>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Hong"
  }
</script>

<style lang="less">
  .top {
    height: 1vh;
    display: flex;

  li {
    float: right;
  }

  .left {
    width: 30%;
    background-color: #d7000f;
  }

  .right {
    flex: 1;
    background-color: #003fa8;
  }

  }
</style>